export default __webpack_public_path__ + "static/media/FISKER.0aa0f60e.png";